import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {App} from './App';
import { preloadPage } from './utils/pageLoader';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

// console.log = () => {};
// console.error = () => {};
// console.warn = () => {};
// console.info = () => {};
// console.debug = () => {};

const renderApp = () => ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

if (sessionStorage.getItem('isLoggedIn') === 'true') {
  preloadPage(localStorage.getItem('currentPage') || 'dashboard')
    .then(renderApp)
    .catch(error => { console.error('Unable to load saved page:', error); window.alert('Unable to load this page. Please reload and try again.'); });
} else {
  renderApp();
}
reportWebVitals();